export default "__VITE_ASSET__Dy$adA_q__"